import { query } from '@/utils/request';

//工作考核明细列表
export async function getOfficeWorkSummaryList(data) {
  return query('/zlb/api/office/work/summary/list', {
    method: 'POST',
    data,
  });
}
